import { Injectable } from '@angular/core';
import {
  AuthResponse,
  AuthChangeEvent,
  AuthOtpResponse,
  AuthSession,
  createClient,
  Session,
  SupabaseClient,
  User,
} from '@supabase/supabase-js';
import { environment } from '../../environments/environment';

export interface Profile {
  id?: string;
  username: string;
  website: string;
  avatar_url: string;
}

@Injectable({
  providedIn: 'root',
})
export class SupabaseService {
  private readonly _client: SupabaseClient;
  private _session: AuthSession | null = null;

  constructor() {
    console.log('create supabase service');
    this._client = createClient(
      environment.supabaseUrl,
      environment.supabaseKey,
    );
  }

  get client(): SupabaseClient {
    return this._client;
  }

  async getSession(): Promise<AuthSession | null> {
    if (!this._session) {
      console.log('getting session');
      this._session = (await this.client.auth.getSession()).data.session;
    }
    return this._session;
  }

  set session(session: AuthSession | null) {
    this._session = session;
  }

  profile(user: User) {
    return this._client
      .from('profiles')
      .select(`username, website, avatar_url`)
      .eq('id', user.id)
      .single();
  }

  authChanges(
    callback: (event: AuthChangeEvent, session: Session | null) => void,
  ) {
    return this.client.auth.onAuthStateChange(callback);
  }

  signIn(email: string, redirectUrl: string): Promise<AuthOtpResponse> {
    console.log(redirectUrl);
    console.log(email);
    return this.client.auth.signInWithOtp({
      email,
      options: {
        emailRedirectTo: redirectUrl,
      },
    });
  }

  signInViaPhone(phone: string): Promise<AuthOtpResponse> {
    return this.client.auth.signInWithOtp({ phone });
  }

  verifyOtp(phone: string, token: string): Promise<AuthResponse> {
    return this.client.auth.verifyOtp({ phone, token, type: 'sms' });
  }

  signOut() {
    return this.client.auth.signOut();
  }

  updateProfile(profile: Profile) {
    const update = {
      ...profile,
      updated_at: new Date(),
    };

    return this._client.from('profiles').upsert(update);
  }

  downLoadImage(path: string) {
    return this._client.storage.from('avatars').download(path);
  }

  uploadAvatar(filePath: string, file: File) {
    return this._client.storage.from('avatars').upload(filePath, file);
  }
}
